import React from "react"
import AppBar from "../app-bar/app-bar"
import AllMessages from "../components/messages/all-messages"
import {useUser} from "../providers/user-context"

function AllMessagesPage({navOpen, toggleNav}) {
    const {userFullName, tenantName, tenantType} = useUser()
    return (
        <div style={{display: "flex", marginTop: "60px"}}>
            <AppBar userFullName={userFullName} tenantName={tenantName} type={tenantType} navOpen={navOpen} toggleNav={toggleNav}/>
            <AllMessages navOpen={navOpen}/>
        </div>
    )
}

export default AllMessagesPage
